import React from "react";
import background from "../assets/images/bg1.jpg";
import Icon1 from "../assets/images/pricon1.png";
import Icon2 from "../assets/images/pricon4.png";
import Icon3 from "../assets/images/pricon2.png";
import Icon4 from "../assets/images/pricon3.png";

function Providers() {
  return (
    <div className="providers my-28 sm:my-10 relative overflow-hidden">

      {/* Background */}
      <img
        className="absolute right-0 bottom-0 z-1 opacity-10"
        src={background}
        alt=""
      />

      {/* Heading */}
      <div className="text-center relative z-2 px-4">
        <h1 className="headingFont text-[#189FAA] sm:text-[40px] md:text-[55px] x:text-[60px] lg:text-[40px] xl:text-[50px] 2xl:text-[60px]">
          For Providers
        </h1>

        <p className="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[70%] headingFont mx-auto sm:text-[16px] md:text-[20px] x:text-[17px] lg:text-[15px] xl:text-[17px] 2xl:text-[21px] text-[#666] leading-8">
          Our user-friendly interface and advanced features enable you to
          deliver high-quality care from anywhere. Join a network of
          forward-thinking healthcare providers and revolutionize your practice
          with cutting-edge technology.
        </p>
      </div>

      {/* Content */}
      <div
        className="
        relative z-2 flex flex-wrap 
        sm:flex-col md:flex-col 
        l:flex-row x:flex-row lg:flex-row xl:flex-row 2xl:flex-row 
        w-[92%] sm:w-[95%] md:w-[90%] lg:w-[80%] 
        mx-auto mt-12 sm:mt-16 lg:mt-20
      "
      >

        {/* CARD 1 */}
        <div
          className="
          flex 
          sm:flex-row md:flex-row
          l:flex-row x:flex-row lg:flex-row xl:flex-row 2xl:flex-row 

          items-start

          l:w-[50%] x:w-[50%] lg:w-[50%] xl:w-[50%] 2xl:w-[50%] 
          sm:w-[100%] md:w-[100%] w-[50%] 

          gap-x-4 

          sm:bg-white sm:rounded-[20px] sm:shadow-md sm:p-4
          md:bg-white md:rounded-[20px] md:shadow-md md:p-5

          sm:mb-6 md:mb-6

          x:bg-transparent l:bg-transparent lg:bg-transparent xl:bg-transparent 2xl:bg-transparent
        "
        >
          <img
            className="
            2xl:w-[150px] 2xl:h-[150px]
            x:w-[100px] x:h-[100px]
            xl:w-[100px] xl:h-[100px]
            lg:w-[80px] lg:h-[80px]

            sm:h-[65px] sm:w-[65px]
            md:h-[75px] md:w-[75px]

            sm:min-w-[65px]
            md:min-w-[75px]

            sm:bg-[#083B8A] sm:p-3 sm:rounded-full
            md:bg-[#083B8A] md:p-3 md:rounded-full
            "
            src={Icon1}
            alt=""
          />

          <div>
            <h1
              className="
              headingFont text-[#189FAA]

              2xl:text-[25px]
              x:text-[22px]
              xl:text-[22px]

              sm:text-left md:text-left
              sm:mt-0 md:mt-0

              sm:text-[24px]
              md:text-[26px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
            "
            >
              Tele Medicine
            </h1>

            <p
              className="
              mt-2 headingFont

              w-[80%]
              sm:w-full
              md:w-full

              sm:text-[15px]
              md:text-[17px]

              2xl:text-[20px]
              xl:text-[16px]
              x:text-[16px]
              lg:text-[14px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
              sm:text-left md:text-left

              2xl:leading-8
              xl:leading-7

              sm:leading-7
              md:leading-8

              text-[#666]

              sm:mx-0 md:mx-0
            "
            >
              Telemedicine leverages technology to connect patients with
              healthcare providers for consultations, diagnosis, and treatment,
              regardless of geographic barriers. High-definition video calls for
              face-to-face interaction with healthcare professionals.
              <br />
              Access to healthcare services at any time, ensuring patients
              receive timely care.
            </p>
          </div>
        </div>

        {/* CARD 2 */}
        <div
          className="
          flex 
          sm:flex-row md:flex-row
          l:flex-row x:flex-row lg:flex-row xl:flex-row 2xl:flex-row 

          items-start

          l:w-[50%] x:w-[50%] lg:w-[50%] xl:w-[50%] 2xl:w-[50%] 
          sm:w-[100%] md:w-[100%] w-[50%] 

          gap-x-4 

          sm:bg-white sm:rounded-[20px] sm:shadow-md sm:p-4
          md:bg-white md:rounded-[20px] md:shadow-md md:p-5

          sm:mb-6 md:mb-6

          x:bg-transparent l:bg-transparent lg:bg-transparent xl:bg-transparent 2xl:bg-transparent
        "
        >
          <img
            className="
            2xl:w-[150px] 2xl:h-[150px]
            x:w-[100px] x:h-[100px]
            xl:w-[100px] xl:h-[100px]
            lg:w-[80px] lg:h-[80px]

            sm:h-[65px] sm:w-[65px]
            md:h-[75px] md:w-[75px]

            sm:min-w-[65px]
            md:min-w-[75px]

            sm:bg-[#083B8A] sm:p-3 sm:rounded-full
            md:bg-[#083B8A] md:p-3 md:rounded-full
            "
            src={Icon2}
            alt=""
          />

          <div>
            <h1
              className="
              headingFont text-[#189FAA]

              2xl:text-[25px]
              x:text-[22px]
              xl:text-[22px]

              sm:text-left md:text-left
              sm:mt-0 md:mt-0

              sm:text-[24px]
              md:text-[26px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
            "
            >
              Electronic Health Records (EHR)
            </h1>

            <p
              className="
              mt-2 headingFont

              w-[80%]
              sm:w-full
              md:w-full

              sm:text-[15px]
              md:text-[17px]

              2xl:text-[20px]
              xl:text-[16px]
              x:text-[16px]
              lg:text-[14px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
              sm:text-left md:text-left

              2xl:leading-8
              xl:leading-7

              sm:leading-7
              md:leading-8

              text-[#666]

              sm:mx-0 md:mx-0
            "
            >
              A comprehensive digital record system for storing and managing
              patient health information. All patient information in one place,
              including medical history, lab results, and treatment plans.
              <br />
              Ensures only authorized personnel can access patient records.
              Allows patients to view their health records and test results
              online.
            </p>
          </div>
        </div>

        {/* CARD 3 */}
        <div
          className="
          flex 
          sm:flex-row md:flex-row
          l:flex-row x:flex-row lg:flex-row xl:flex-row 2xl:flex-row 

          items-start

          l:w-[50%] x:w-[50%] lg:w-[50%] xl:w-[50%] 2xl:w-[50%] 
          sm:w-[100%] md:w-[100%] w-[50%] 

          gap-x-4 

          sm:bg-white sm:rounded-[20px] sm:shadow-md sm:p-4
          md:bg-white md:rounded-[20px] md:shadow-md md:p-5

          sm:mb-6 md:mb-6

          x:bg-transparent l:bg-transparent lg:bg-transparent xl:bg-transparent 2xl:bg-transparent
        "
        >
          <img
            className="
            2xl:w-[150px] 2xl:h-[150px]
            x:w-[100px] x:h-[100px]
            xl:w-[100px] xl:h-[100px]
            lg:w-[80px] lg:h-[80px]

            sm:h-[65px] sm:w-[65px]
            md:h-[75px] md:w-[75px]

            sm:min-w-[65px]
            md:min-w-[75px]

            sm:bg-[#083B8A] sm:p-3 sm:rounded-full
            md:bg-[#083B8A] md:p-3 md:rounded-full
            "
            src={Icon3}
            alt=""
          />

          <div>
            <h1
              className="
              headingFont text-[#189FAA]

              2xl:text-[25px]
              x:text-[22px]
              xl:text-[22px]

              sm:text-left md:text-left
              sm:mt-0 md:mt-0

              sm:text-[24px]
              md:text-[26px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
            "
            >
              Scheduling Appointment
            </h1>

            <p
              className="
              mt-2 headingFont

              w-[80%]
              sm:w-full
              md:w-full

              sm:text-[15px]
              md:text-[17px]

              2xl:text-[20px]
              xl:text-[16px]
              x:text-[16px]
              lg:text-[14px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
              sm:text-left md:text-left

              2xl:leading-8
              xl:leading-7

              sm:leading-7
              md:leading-8

              text-[#666]

              sm:mx-0 md:mx-0
            "
            >
              A user-friendly platform for patients to schedule, reschedule, or
              cancel appointments with their healthcare providers. Simple and
              intuitive interface for booking appointments. View and select
              available time slots in real-time.
            </p>
          </div>
        </div>

        {/* CARD 4 */}
        <div
          className="
          flex 
          sm:flex-row md:flex-row
          l:flex-row x:flex-row lg:flex-row xl:flex-row 2xl:flex-row 

          items-start

          l:w-[50%] x:w-[50%] lg:w-[50%] xl:w-[50%] 2xl:w-[50%] 
          sm:w-[100%] md:w-[100%] w-[50%] 

          gap-x-4 

          sm:bg-white sm:rounded-[20px] sm:shadow-md sm:p-4
          md:bg-white md:rounded-[20px] md:shadow-md md:p-5

          sm:mb-6 md:mb-6

          x:bg-transparent l:bg-transparent lg:bg-transparent xl:bg-transparent 2xl:bg-transparent
        "
        >
          <img
            className="
            2xl:w-[150px] 2xl:h-[150px]
            x:w-[100px] x:h-[100px]
            xl:w-[100px] xl:h-[100px]
            lg:w-[80px] lg:h-[80px]

            sm:h-[65px] sm:w-[65px]
            md:h-[75px] md:w-[75px]

            sm:min-w-[65px]
            md:min-w-[75px]

            sm:bg-[#083B8A] sm:p-3 sm:rounded-full
            md:bg-[#083B8A] md:p-3 md:rounded-full
            "
            src={Icon4}
            alt=""
          />

          <div>
            <h1
              className="
              headingFont text-[#189FAA]

              2xl:text-[25px]
              x:text-[22px]
              xl:text-[22px]

              sm:text-left md:text-left
              sm:mt-0 md:mt-0

              sm:text-[24px]
              md:text-[26px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
            "
            >
              e-Prescription
            </h1>

            <p
              className="
              mt-2 headingFont

              w-[80%]
              sm:w-full
              md:w-full

              sm:text-[15px]
              md:text-[17px]

              2xl:text-[20px]
              xl:text-[16px]
              x:text-[16px]
              lg:text-[14px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
              sm:text-left md:text-left

              2xl:leading-8
              xl:leading-7

              sm:leading-7
              md:leading-8

              text-[#666]

              sm:mx-0 md:mx-0
            "
            >
              e-Prescription streamlines the prescription process by allowing
              healthcare providers to send prescriptions directly to pharmacies
              electronically. Quick and secure transmission of prescriptions to
              the patient's preferred pharmacy.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Providers;